import { Injectable } from '@angular/core';
import { DocumentAttachment } from '@icc/b2b/shared';

interface ExtendedDocumentAttachment extends DocumentAttachment {
  preview: string;
}

@Injectable({
  providedIn: 'root'
})
export class ComplaintAppointmentService {
	private complaintAppointmentAttachmentsMap: Map<string, DocumentAttachment[]> = new Map();
	private additionalProtocolFilesMap: Map<string, ExtendedDocumentAttachment[]> = new Map();

	constructor() {}

	getAttachments(appointmentUuid: string): DocumentAttachment[] {
	    return this.complaintAppointmentAttachmentsMap.get(appointmentUuid) || [];
	}

	getAdditionalProtocolFiles(appointmentUuid: string): ExtendedDocumentAttachment[] {
		return this.additionalProtocolFilesMap.get(appointmentUuid) || [];
	}

	addAttachment(appointmentUuid: string, attachment: DocumentAttachment): void {
		const attachments = this.getAttachments(appointmentUuid);
		attachments.push(attachment);
		this.complaintAppointmentAttachmentsMap.set(appointmentUuid, attachments);
	}

	addAdditionalProtocolFile(appointmentUuid: string, attachment: ExtendedDocumentAttachment): void {
		const attachments = this.getAdditionalProtocolFiles(appointmentUuid);
		attachments.push(attachment);
		this.additionalProtocolFilesMap.set(appointmentUuid, attachments);
	}

	removeAttachment(appointmentUuid: string, attachmentUuid: string): void {
		const attachments = this.getAttachments(appointmentUuid).filter(att => att.uuid !== attachmentUuid);
		this.complaintAppointmentAttachmentsMap.set(appointmentUuid, attachments);
	}

	removeAdditionalProtocolFile(appointmentUuid: string, attachmentUuid: string): void {
		const attachments = this.getAdditionalProtocolFiles(appointmentUuid).filter(att => att.uuid !== attachmentUuid);
		this.additionalProtocolFilesMap.set(appointmentUuid, attachments);
	}
}
